import Vue from 'vue';
import App from './App.vue';
import store from '@/store';

Vue.config.productionTip = false;

Vue.filter('dotdotdot', function (value, length) {
  let dots = value.length > length ? '...' : '';
  return value.substr(0, length) + dots;
});

new Vue({
  render: h => h(App),
  store,
}).$mount('#app');
